var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[(_vm.tabs.length)?_c('ul',_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:index},[_c('button',{class:index === _vm.active ? 'active' : '',on:{"click":function($event){return _vm.$emit('input', index)}}},[_vm._v("\n        "+_vm._s(tab.title)+"\n      ")])])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }